function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#fef7cf",
    d: "M 232.5,-0.5 C 247.833,-0.5 263.167,-0.5 278.5,-0.5C 368.144,10.3879 435.644,54.7213 481,132.5C 497.695,163.971 507.861,197.304 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 500.612,368.144 456.279,435.644 378.5,481C 347.029,497.695 313.696,507.861 278.5,511.5C 263.167,511.5 247.833,511.5 232.5,511.5C 142.856,500.612 75.3562,456.279 30,378.5C 13.3053,347.029 3.1386,313.696 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 10.3875,142.857 54.7208,75.3573 132.5,30C 163.971,13.3053 197.304,3.1386 232.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6541",
    d: "M 162.5,171.5 C 183.711,169.346 197.545,178.346 204,198.5C 205.531,218.601 196.698,231.767 177.5,238C 157.008,240.009 143.842,231.175 138,211.5C 135.751,191.648 143.917,178.315 162.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6440",
    d: "M 332.5,171.5 C 361.842,170.34 375.342,184.34 373,213.5C 366.107,231.7 352.941,239.866 333.5,238C 314.312,231.793 305.479,218.627 307,198.5C 310.604,184.733 319.104,175.733 332.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6440",
    d: "M 149.5,337.5 C 220.167,337.333 290.834,337.5 361.5,338C 371.805,342.11 375.639,349.61 373,360.5C 371.058,366.776 366.891,370.61 360.5,372C 289.833,372.667 219.167,372.667 148.5,372C 138.843,367.061 135.343,359.228 138,348.5C 140.495,343.353 144.329,339.686 149.5,337.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral2);
export default __webpack_public_path__ + "static/media/neutral 2.6041d9f025afe9d84ee1e6379c11993e.svg";
export { ForwardRef as ReactComponent };